module.exports = __webpack_public_path__ + "static/media/logo.d45f4c67.svg";